module.exports = __webpack_public_path__ + "static/media/check-circle.8f4f12c1.svg";